<template>
  <div class="px-16">
    <c-label :color="$theme.COLOR.UI.UI13" :weight="500" :size="16" :lineHeight="16"
      >{{ $t('title.eventHistory') }}
    </c-label>
    <div class="content-wrapper">
      <div class="area">
        <ConfigTitle required class="title">{{ $t('label.widgetName') }}</ConfigTitle>
        <lego-text-field
          ref="widgetName"
          :rules="validator.widgetName"
          :modelValue="widgetName"
          counter="100"
          showCounter
          :guide="$t('hint.common') + ' ' + $t('hint.notStartWithDot')"
          @update:modelValue="(value) => changeWidgetName(value)"
          isFreeText
        />
      </div>
      <BoxRegion class="area" />
    </div>
  </div>
</template>
<script>
import configMixin from './configMixin';
import validateFieldsMixin from '@/mixins/validateFields.mixin';

export default {
  props: ['configItem'],
  mixins: [configMixin, validateFieldsMixin],
  emits: ['update:changeField'],
  data() {
    return {
      isChanged: false,
      widgetName: '', // 위젯명
      defaultConfig: this.config({
        // 이벤트 히스토리 위젯 기본 설정 정보
        title: this.$t('title.eventHistory'),
        w: 4,
        minW: 4,
        maxW: 4,
        widget: {
          type: 'EventHistoryWidget',
          api: '/cloudmonitorings/event/v1/console/events/event-history',
          options: {}
        }
      }),
      validator: {
        widgetName: [this.checkWidgetName]
      },
      validateFieldKey: 'eventHistoryWidgetConfig'
    };
  },
  watch: {
    changedFieldData: {
      handler(value) {
        this.$emit('update:changeField', value);
      },
      immediate: true
    }
  },
  mounted() {
    this.setFieldsBeforeModify();
  },
  methods: {
    validate() {
      return this.$util.validate([this.$refs.widgetName]);
    },
    setDefault() {},
    // 위젯 설정 정보 update
    onConfigChange(isApiCall = true) {
      let configs = [];
      let config = this.getCommonConfig();
      config.chartAttr.title = this.widgetName;
      config.isApiCall = isApiCall;
      configs.push(config);

      this.checkCount++;
      if (this.checkCount === 1) this.originConfigs = configs;

      //console.log('EventHistortyWidget', 'this.config - ', configs);
      this.$emit('configModify', configs);
    }
  }
};
</script>
<style lang="scss" scoped>
.area {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;

  &:first-child {
    margin-bottom: 8px;
  }
}

.content-wrapper {
  margin-top: 24px;
}
</style>
